export default "__VITE_ASSET__BWPE9hIr__"